<div
  class="app-layout app-vertical-layout"
  *ngIf="isLoggedIn"
  [class]="isLoading ? 'loader-overlay loading' : ''">
  <header class="app-header">
    <div class="logo">
      <a>
        <img src="assets/images/bombardier-ssics-logo-white.svg" alt="" />
      </a>
      <h4>
        {{ portalTitle }}
      </h4>
    </div>
    <div class="welcome">
      {{ welcomeText }}
    </div>
    <div>
      <dx-drop-down-button
        #userMenu
        [icon]="userPhotoUrl ? userPhotoUrl : ''"
        [text]="fullName"
        [deferRendering]="false"
        [useSelectMode]="false"
        [showArrowIcon]="false"
        stylingMode="text"
        dropDownContentTemplate="contentTemplate"
        [dropDownOptions]="{ width: 230 }">
        <div *dxTemplate="let field of 'item'">
          <a
            href="javascript:void(0)"
            class="user user-md"
            [title]="fullName"
            (click)="$event.stopPropagation(); userMenu.opened = !userMenu.opened">
            <span *ngIf="fullName?.length > 0" class="name">{{ fullName }} </span>
            <b
              class="user-photo"
              [ngStyle]="{
                'background-image':
                  'url(' + (portalUser?.photoFileUri ? portalUser?.photoFileUri : '') + ')',
              }"
              >{{ !portalUser?.photoFileUri ? getUserShortName() : '' }}</b
            >
            <i class="icon-angle-down text-medium fs20"></i>
          </a>
        </div>
        <div *dxTemplate="let item of 'contentTemplate'">
          <ul class="dropdown-menu" (click)="userMenu.opened = false">
            <li>
              <a href="javascript:void(0)" (click)="onSignOutClick()">{{
                'general.logout' | translate
              }}</a>
            </li>
          </ul>
        </div>
      </dx-drop-down-button>
    </div>
  </header>

  <div class="app-content">
    <router-outlet (activate)="onRouteActivate()"></router-outlet>
  </div>

  <footer class="app-footer">
    <a
      *ngIf="portalMode === SysExternalWebUserType.SSICSASFPortal"
      [attr.href]="
        'mailto:&quot;' +
        ('general.company' | translate) +
        '&quot;<' +
        ('general.companyEmail' | translate) +
        '>'
      ">
      {{ 'general.companyEmail' | translate }}
    </a>
    <a href="javascript:void(0)" *ngIf="legalText" (click)="onlegalNoticePopupClick()">
      {{ 'general.legalNotice' | translate }}
    </a>
    <a
      href="javascript:void(0)"
      *ngIf="
        portalMode === SysExternalWebUserType.SSICSClientPortal &&
        portalConfig?.clientPortalContactUs
      "
      (click)="onContactUsClick()">
      {{ 'referenceTables.contactUs' | translate }}
    </a>
    <span>&copy; {{ 'general.company' | translate }} {{ currentYear }}</span>
  </footer>
</div>

<div class="h100" *ngIf="!isLoggedIn">
  <app-login></app-login>
</div>

<shared-popup
  [(visible)]="showLegalNotice"
  [panelClass]="'popup small'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div *appPopupTemplate>
    <div class="app-modal app-modal-simple">
      <div class="app-modal-header">
        <h1>
          <div>{{ 'general.legalNotice' | translate }}</div>
        </h1>
        <a href="javascript:void(0)" class="app-modal-close-icon" (click)="closeEditMode()"> </a>
      </div>
      <div class="app-modal-content">
        <div class="app-form-panel app-form-panel-simple">
          <div class="app-form-panel-content">
            {{ legalText }}
          </div>
        </div>
      </div>
      <div class="app-modal-footer aright">
        <a
          href="javascript:void(0)"
          (click)="closeEditMode()"
          class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads">
          {{ 'actions.cancel' | translate }}
        </a>
      </div>
    </div>
  </div>
</shared-popup>

<shared-popup
  [(visible)]="showContactUs"
  [panelClass]="'popup small'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div *appPopupTemplate>
    <div class="app-modal app-modal-simple">
      <div class="app-modal-header">
        <h1>
          <div>{{ 'referenceTables.contactUs' | translate }}</div>
        </h1>
        <a href="javascript:void(0)" class="app-modal-close-icon" (click)="closeEditMode()"> </a>
      </div>
      <div class="app-modal-content">
        <div class="app-form-panel app-form-panel-simple">
          <div class="app-form-panel-content">
            {{ portalConfig?.clientPortalContactUs }}
          </div>
        </div>
      </div>
      <div class="app-modal-footer aright">
        <a
          href="javascript:void(0)"
          (click)="closeEditMode()"
          class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads">
          {{ 'actions.cancel' | translate }}
        </a>
      </div>
    </div>
  </div>
</shared-popup>

<shared-popup
  [(visible)]="showRefreshPopup"
  [panelClass]="'popup small'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div class="app-modal app-modal-simple new-version-popup">
    <div class="app-modal-content">
      <div class="app-form-panel app-form-panel-simple">
        <div class="app-form-panel-content acenter">
          <div>
            <img
              src="../../../../../assets/images/icon-lightbulb.svg"
              alt=""
              style="width: 170px" />
          </div>
          <h1>
            {{ 'general.newVersionAvailable' | translate }}
          </h1>
          <div class="fs15">
            {{ 'general.newVersionRefreshText' | translate }}
          </div>
          <div class="mt40">
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-rounded simple-btn-primary simple-btn-md bigger-side-pads"
              (click)="updateToLatest()">
              {{ 'actions.refresh' | translate }}
            </a>
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads"
              (click)="showRefreshPopup = false">
              {{ 'actions.cancel' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</shared-popup>
